<template>
  <main>
    <div class="bg-gray-200 py-2">
      <div class="breadcrumbs container mx-auto">
        <nuxt-link :to="localePath('index')" class="breadcrumb  px-2">
          {{ $t('home') }}</nuxt-link
        >
        <nuxt-link :to="localePath('news')" class="breadcrumb  px-2">
          {{ $t('news') }}</nuxt-link
        >
        <nuxt-link
          :to="localePath({ name: 'post-slug', params: { slug: post.slug } })"
          class="breadcrumb px-2"
        >
          {{ post.name }}</nuxt-link
        >
      </div>
    </div>
    <section class="solution px-4 container mx-auto">
      <div class="solution-content bg-white px-8 py-8 md:px-20 md:py-20">
        <h1 class="text-4xl text-black font-bold mb-4">
          {{ post.name }}
        </h1>

        <!-- ovako bila samo jedna slika -->
        <!-- <img
          :src="`/img/news/${post.img}`"
          class="post-img max-w-full h-auto mb-4"
        /> -->

        <!-- dole ide slider  -->

        <div>
          <!-- Ako post.img je niz slika, prikaži slajder -->
          <template v-if="Array.isArray(post.img)">
            <div v-swiper:mySwiper="swiperOption" class="swiper-container">
              <div class="swiper-wrapper py-16">
                <!-- slides -->
                <div
                  v-for="(image, index) in post.img"
                  :key="index"
                  class="swiper-slide"
                >
                  <img
                    :src="`/img/news/${image}`"
                    class="post-img max-w-full h-auto mb-4"
                    alt="post image"
                  />
                </div>
              </div>
              <!-- Optional controls -->
              <div slot="pagination" class="mt-24 swiper-pagination"></div>
              <div
                slot="button-prev"
                class="hidden sm:block swiper-button-prev"
              ></div>
              <div
                slot="button-next"
                class="hidden sm:block swiper-button-next"
              ></div>
            </div>
          </template>

          <!-- Ako post.img je jedna slika, prikaži samo tu sliku -->
          <template v-else>
            <img
              :src="`/img/news/${post.img}`"
              class="post-img max-w-full h-auto mb-4"
              alt="post image"
            />
          </template>
        </div>

        <!-- gore ide slider -->

        <div v-html="post.content" class="text-grey-600 mb-5"></div>
        <video
          v-if="post.video"
          :muted="muted"
          @click="muted = !muted"
          class="text-grey-600 mb-5  mx-auto"
          style="max-height: 700px"
          autoplay
          playsinline
          poster="/img/career_poster.jpeg"
        >
          <source :src="post.video" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div class="text-center my-6 pb-4">
        <h4 class="font-bold text-2xl">{{ $t('anything_you_need_help') }}</h4>
        <div class="flex flex-wrap justify-center">
          <nuxt-link
            :to="localePath('posts')"
            class="button w-56 bg-red-600 hover:bg-red-700 px-12 uppercase hover:text-white mt-6 sm:mr-3 text-white px-5 py-3"
            >{{ $t('OUR_SOLUTIONS') }}</nuxt-link
          >
          <nuxt-link
            :to="localePath('contact')"
            class="button w-56 bg-transparent text-black uppercase border-2 border-black px-5 py-3 mt-6 hover:bg-black hover:text-white"
            >{{ $t('contact') }}</nuxt-link
          >
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import posts from '~/static/posts.json'
// eslint-disable-next-line no-console
// console.log(posts)
export default {
  data() {
    return {
      muted: true,
      // ovde dodato ovo dole
      active: 1,
      swiperOption: {
        slidesPerView: 'auto',
        centeredSlides: true,
        autoHeight: true,
        spaceBetween: 10,
        loop: true,
        autoplay: {
          delay: 7500, // Vreme zadržavanja između slajdova (u milisekundama)
          disableOnInteraction: false // Omogućava autoplay i nakon interakcije korisnika (klik, prevlačenje)
        },
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        allowTouchMove: false,
        slidesPerGroup: 1,
        breakpoints: {
          1024: {
            slidesPerView: 1,
            spaceBetween: 10,
            allowTouchMove: true
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 10,
            allowTouchMove: true
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 10,
            allowTouchMove: true
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
            allowTouchMove: true
          }
        }
      }
    }
  },
  asyncData({ route, params }) {
    const slug = params.slug
    const post = posts.find(post => {
      return post.slug === slug
    })

    return { post, slug }
  },
  head() {
    // Definišemo kanonski link direktno
    const canonicalLink = {
      rel: 'canonical',
      href: `https://milsped.com${this.$route.path}/` // Osigurajte da je ovo vaša osnovna domena
    }
          // eslint-disable-next-line no-console
    console.log(canonicalLink)

    // Vraćamo objekat head sa kanonskim linkom
    return {
      link: [canonicalLink]
    }
  },
  mounted() {}
}
</script>

<style scoped>
.header {
  background: linear-gradient(to right, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0)),
    url('/img/about_header_background.jpg');
  background-position: center;
  background-size: cover;
  position: relative;
}
.header:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  transform: translateY(100%);
  left: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.05), transparent);
  z-index: -1;
}
.post-content {
  transform: translateY(-75px);
  z-index: 999;
}
.card {
  display: flex;
  margin-bottom: 35px;
  min-height: 300px;
  /* max-height: 350px; */
}
.card img {
  width: 100%;
  height: auto;
  margin-bottom: 15px;
}
.additional-info h3 {
  @apply my-3;
  @apply font-bold;
}
.additional-info p {
  background: red;
}
@screen md {
  .card:nth-child(odd) {
    flex-direction: row-reverse;
  }

  .card:nth-child(even) div {
    padding-left: 25px;
    padding-right: 0;
  }
  .card img {
    width: 50%;
    height: auto;
    max-height: 350px;
  }
  .card div {
    padding-right: 25px;
    width: 50%;
  }
}

/* ovde stil za swipper */

.post-name {
  line-height: 1.1;
}
.post-container {
  transition: 0.3s;
  position: relative;
  /* outline: 2px solid green; */
  min-height: 400px;
  opacity: 0.75;
}
.img-wrapper {
  display: none;
}
.post-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.swiper-slide {
  width: 100%;
}
@screen lg {
  .swiper-slide {
    /* width: 20%; */
    width: 100%;
  }
  .img-wrapper {
    align-self: center;
    /* width: 50%; */
    width: 100%;
    /* padding: 0 10px; */
    /* height: 350px; */
    height: 550px;
  }
  .swiper-slide-active {
    /* width: 59%; */
    width: 100%;
  }
  .swiper-slide-active .post-name {
    @apply text-2xl;
  }
  .swiper-slide-active .post-description {
    @apply text-sm;
  }
  .swiper-slide-active .post-content {
    /* width: 50%; */
    width: 100%;
  }
}
.post-button {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.swiper-slide-active .post-container {
  /* outline: 3px solid blue; */
  opacity: 1;
  /* opacity: 0.9; */
  @apply shadow-lg;
}
.swiper-slide-active .post-button {
  display: block;
}
.post-content {
  padding: 11px;
  /* padding: 10px; */
}

.swiper-slide-active .img-wrapper {
  display: block;
}
</style>
